export default __webpack_public_path__ + "static/media/smile.7e4794f4.svg";